export default __webpack_public_path__ + "static/media/790895058235817985.38a5e548.png";